import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2'

function Navbar1({cart, quitItemCart, setQuantityInput, setIncrementDecrement, limpiarCarrito, sendQuotationWhastapp}) {

    const [categories, setCategories] = useState([]);

    const [textSearch, setTextSearch] = useState('');

    const [optionTag, setOptionTag] = useState('');

    const [taglist, setTaglist] = useState([]);

    //CON setTimeout
    /*useEffect(() => {
        const timer = setTimeout(() => {
            const items = document.querySelectorAll('.kreen-menu-clone-wrap a[data-id]');

            items.forEach(item => {
                item.addEventListener('click', handleClick);
            });

            function handleClick(e) {
                e.preventDefault();

                const id = e.currentTarget.getAttribute('data-id');
                if (id) {
                    getProducts(id);
                }
            }

            return () => {
                items.forEach(item => {
                    item.removeEventListener('click', handleClick);
                });
            };
        }, 1000); // darle tiempo al clonador

        return () => clearTimeout(timer);

    }, [categories]);*/

    useEffect(() => {
        getTags();
    }, []);

    /*useEffect(() => {
        getCategories();
    }, []);

    //OTRA FORMA CON MutationObserver
    useEffect(() => {

        const observer = new MutationObserver(() => {
            const items = document.querySelectorAll('.kreen-menu-clone-wrap a[data-id]');
                items.forEach(item => {
                item.addEventListener('click', handleClick);
            });
        });

        function handleClick(e) {
            e.preventDefault();
            const id = e.currentTarget.getAttribute('data-id');
            if (id) getProducts(id);
        }

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();

    }, [categories]);*/

    function getTags() {
        
        //let _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');//obtenemos el token del form
        let url = '/api/tags_list';

        fetch(url, {
            method: "GET",
            headers: {
                //'X-CSRF-TOKEN': _token //asignamos el token frm a los headers
            },
            //body: formData,

        }).then ( response => response.json())
        .then ( data => {
            if (data.response == 'success') {
                
                setTaglist(data.data);

            }
            if (data.response == 'info') {
                console.log(data.message);
            }


        }).catch(error =>{
            console.error(error);
        });
    }

    function getCategories() {
        
        //let _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');//obtenemos el token del form
        let url = '/api/category_list';

        fetch(url, {
            method: "GET",
            headers: {
                //'X-CSRF-TOKEN': _token //asignamos el token frm a los headers
            },
            //body: formData,

        }).then ( response => response.json())
        .then ( data => {
            if (data.response == 'success') {
                
                setCategories(data.data);
            }
            if (data.response == 'info') {
                console.log(data.message);
            }


        }).catch(error =>{
            console.error(error);
        });
    }

    const getProducts = (idsubcategory) => {
        //let _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');//obtenemos el token del form
        let url = '/api/products_subcategory_list';

        const formData = new FormData();
        formData.append('id_subcategory', idsubcategory);

        fetch(url, {
            method: "POST",
            headers: {
                //'X-CSRF-TOKEN': _token //asignamos el token frm a los headers
            },
            body: formData,

        }).then ( response => response.json())
        .then ( data => {
            if (data.response == 'success') {
                
                setProducts(data.data);
            }
            if (data.response == 'info') {
                console.log(data.message);
                setProducts([]);
            }


        }).catch(error =>{
            console.error(error);
        });
    }

    const handleGetProducts = (idsubcategory) => {
        getProducts(idsubcategory);
    }

    const handleInputQuantity = (e) => {

        let value = e.target.value;

        let index = e.target.getAttribute('data-index');

        setQuantityInput(index, value);
    }

    function totalCart() {
        const c_cart = [...cart];

        let total = 0;

        c_cart.forEach(elm => {
            total += elm.subtotal;
        });

        return total;
    }

    const handleTextSearch = (e) => {
        let value = e.target.value;

        setTextSearch(value);
    }

    const changeSelectTagSearch = (e) => {

        const option = e.target.options[e.target.selectedIndex];
        // Acceder a data-type u otro data-*
        //const max = option.getAttribute('data-max');

        const value = e.target.value;

        if (value != '') {
            
            let objsel = {
                textsearch: textSearch,
                tagsearch: value,
                page: 0,
                h_p_p: 10
            };

            //let val = textSearch;
            localStorage.setItem('valueBarSearch', JSON.stringify(objsel));

            //window.open('/');
            window.location.href = '/products_found';
        }
    }

    const redirectAndSearchProducts = () => {

        if (textSearch != '') {
            
            //alert('REEDIRIGIENDO...')
            let obj = {
                textsearch: textSearch,
                tagsearch: optionTag,
                page: 0,
                h_p_p: 10
            };

            //let val = textSearch;
            localStorage.setItem('valueBarSearch', JSON.stringify(obj))

            //window.open('/');
            window.location.href = '/products_found';

        } else {
            //Swal.fire('¡Espere!', 'No puedes hacer una búsqueda si no has agregado o seleccionado un valor, inténtelo de nuevo.', 'info');

            Swal.fire({
                icon: 'info',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true, 
                title: 'Lo siento, no puedes realizar una busqueda si no has agregado un valor',
                customClass: {
                    container: 'mi-sweetalert-container',
                },
            });
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            redirectAndSearchProducts();
            e.preventDefault();
            //alert(`Enviado con Enter: ${textSearch}`);
        }
    };
 
    return (
        <header id="header" className="header style-03 header-dark header-sticky header-transparent">
            <div className="header-wrap-stick">
                <div className="header-position">
                    <div className="header-middle">
                        <div className="kreen-menu-wapper"></div>
                        <div className="header-middle-inner">
                            <div className="header-logo">
                                <a href="/">
                                    <img alt="Kreen" src="https://res.cloudinary.com/dlaew2qjk/image/upload/v1770757004/san_jose/LOGO_DSJ.png" className="logo" style={{width:"500px"}} />
                                </a>
                            </div>
                            
                            <div className="header-menu">
                                <div className="box-header-nav menu-nocenter">
                                    <ul id="menu-primary-menu" className="clone-main-menu kreen-clone-mobile-menu kreen-nav main-menu">
                                        
                                    </ul>
                                </div>
                                <div className="block-menu-bar">
                                    <a className="menu-bar menu-toggle" href="#">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                            
                            <div className="header-control">
                                <div className="header-control-inner">
                                    
                                    <div className="meta-dreaming">
                                        {
                                            <>
                                            <div className="header-search kreen-dropdown">
                                                <div className="header-search-inner" data-kreen="kreen-dropdown">
                                                    <a href="#" className="link-dropdown block-link">
                                                        <span className="pe-7s-search"></span>
                                                    </a>
                                                </div>
                                                <div className="block-search">
                                                    <div className="form-search block-search-form kreen-live-search-form">
                                                        <div className="form-content search-box results-search">
                                                            <div className="inner">
                                                                <input autoComplete="off" onChange={handleTextSearch} onKeyDown={handleKeyDown} className="searchfield txt-livesearch input"
                                                                    name="s" value={textSearch} placeholder="Buscar aquí..." type="text" />
                                                            </div>
                                                        </div>
                                                        <input name="post_type" value="product" type="hidden" />
                                                        <input name="taxonomy" value="product_cat" type="hidden" />
                                                        <div className="category">
                                                            <select title="product_cat" onChange={changeSelectTagSearch} name="product_cat"
                                                                    className=""
                                                                    tabIndex="-1">
                                                                <option value="">Seleccione Tag</option>
                                                                {
                                                                    taglist.map((tag, index) => (
                                                                        <option className="level-0" key={index} value={tag}>{tag}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <button type="button" onClick={()=>redirectAndSearchProducts()} className="btn-submit">
                                                            <span className="pe-7s-search"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="kreen-dropdown-close">x</div>
                                            </>
                                            /*
                                            <div className="menu-item block-user block-dreaming kreen-dropdown">
                                                <a className="block-link" href="my-account.html">
                                                    <span className="pe-7s-user"></span>
                                                </a>
                                                <ul className="sub-menu">
                                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--dashboard is-active">
                                                        <a href="#">Dashboard</a>
                                                    </li>
                                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--orders">
                                                        <a href="#">Orders</a>
                                                    </li>
                                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--downloads">
                                                        <a href="#">Downloads</a>
                                                    </li>
                                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-adchair">
                                                        <a href="#">Addresses</a>
                                                    </li>
                                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-account">
                                                        <a href="#">Account details</a>
                                                    </li>
                                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--customer-logout">
                                                        <a href="#">Logout</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            */
                                        }
                                        <div className="block-minicart block-dreaming kreen-mini-cart kreen-dropdown">
                                            <div className="shopcart-dropdown block-cart-link" data-kreen="kreen-dropdown">
                                                <a className="block-link link-dropdown" href="cart.html">
                                                    <span className="pe-7s-shopbag"></span>
                                                    <span className="count">{cart.length}</span>
                                                </a>
                                            </div>
                                            <div className="widget kreen widget_shopping_cart">
                                                <div className="widget_shopping_cart_content">
                                                    <h3 className="minicart-title">Tu Carrito<span className="minicart-number-items">{cart.length}</span></h3> 
                                                    <ul className="kreen-mini-cart cart_list product_list_widget">
                                                        {
                                                            cart.length > 0 ?
                                                            <>
                                                            <p className='text-primary text-small' style={{width:'400px', overflowWrap:'break-word', paddingLeft:'30px', fontSize:'13px', textAlign:'justify'}}><i className="fa fa-info-circle"></i> Los precios que se muestran son aproximados, pueden cambiar de acuerdo a su gramaje real. Por favor, para obtener mejor información de los precios, hacer click en el botón <b>COTIZAR</b> para ponerse en contacto con el vendedor.</p>
                                                            </>
                                                            : 
                                                            <div className='text-center'>
                                                                <h3 className='text-muted'>El carrito está vacío</h3>
                                                            </div>
                                                        }
                                                        {
                                                            /*
                                                            <li className="kreen-mini-cart-item mini_cart_item">
                                                                <a href="#" className="remove remove_from_cart_button">×</a>
                                                                <a href="#">
                                                                    <img src="/assets/images/apro134-1-600x778.jpg"
                                                                        className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                                        alt="img" width="600" height="778" />T-shirt with skirt – Pink&nbsp;
                                                                </a>
                                                                <span className="quantity">1 × <span
                                                                        className="kreen-Price-amount amount"><span
                                                                        className="kreen-Price-currencySymbol">$</span>150.00</span></span>
                                                            </li>
                                                             */

                                                            cart.map((item, index) => (
                                                                <li className="kreen-mini-cart-item mini_cart_item" key={item.productDessId}>
                                                                    <a onClick={()=>quitItemCart(item.productDessId)} className="remove remove_from_cart_button" style={{cursor: "pointer"}}>×</a>
                                                                    <a href="#">
                                                                        <img src={item.url_img_product}
                                                                            className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                                            alt="img" width="600" height="778" />{item.description}&nbsp;
                                                                    </a>
                                                                    <span className="quantity">
                                                                        {
                                                                            item.product_type.tipoProductoId == 2 ?
                                                                            <span>
                                                                                <input type="number" data-step="1" step="0.01" data-index={index} max="" onChange={handleInputQuantity} value={item.quantity} title="Qty" className="input-qty input-text qty text border-dark" size="1" pattern="[0-9]*" inputMode="numeric" style={{width: '75px'}} />
                                                                            </span>
                                                                            :
                                                                            <span style={{paddingRight: '10px'}}>
                                                                                <button type='button' onClick={()=>setIncrementDecrement(index, 'decrement')} className="btn btn-dark btn-sm" style={{cursor: "pointer"}}>-</button>
                                                                                <input type="number" data-step="1" min="1" data-index={index} max="" onChange={handleInputQuantity} value={item.quantity} title="Qty" className="input-qty input-text qty text border-dark" size="1" pattern="[0-9]*" inputMode="numeric" style={{width: '75px'}} />
                                                                                <button type='button' onClick={()=>setIncrementDecrement(index, 'increment')} className="btn btn-dark btn-sm" style={{cursor: "pointer"}}>+</button>
                                                                            </span>

                                                                        }
                                                                        <span className='text-muted' style={{paddingRight: '10px'}}>
                                                                            {item.dess_unidade.abreviatura}
                                                                        </span>
                                                                        <span style={{paddingRight: '10px'}}>
                                                                            × 
                                                                        </span>
                                                                        <span className="kreen-Price-amount amount">
                                                                            <span className="kreen-Price-currencySymbol">$</span>{parseFloat(item.price1).toFixed(2)}
                                                                        </span>
                                                                    </span>
                                                                    <div className='text-right text-primary'>
                                                                        ${parseFloat(item.subtotal).toFixed(2)}
                                                                    </div>
                                                                </li>
                                                            ))
                                                        }

                                                    </ul>
                                                    <p className="kreen-mini-cart__total total"><strong>Subtotal:</strong>
                                                        <span className="kreen-Price-amount amount"><span
                                                                className="kreen-Price-currencySymbol">$</span>{parseFloat(totalCart()).toFixed(2)}</span>
                                                    </p>
                                                    <p className="kreen-mini-cart__buttons buttons">
                                                        {
                                                            cart.length > 0 ?
                                                            <>
                                                                <a href="#" onClick={()=>limpiarCarrito()} className="button kreen-forward">VACIAR CARRITO</a>
                                                                <a href="#" onClick={()=>sendQuotationWhastapp()} className="button checkout kreen-forward">COTIZAR</a>
                                                            </>
                                                            :
                                                            null
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header-mobile">
                <div className="header-mobile-left">
                    {
                    /*
                    <div className="block-menu-bar">
                        <a className="menu-bar menu-toggle" href="#">
                            <span></span>
                            <span></span>
                            <span></span>
                        </a>
                    </div>
                    */
                   <>
                    <div className="header-search kreen-dropdown">
                        <div className="header-search-inner" data-kreen="kreen-dropdown">
                            <a href="#" className="link-dropdown block-link">
                                <span className="pe-7s-search"></span>
                            </a>
                        </div>
                        <div className="block-search">
                            <div className="form-search block-search-form kreen-live-search-form">
                                <div className="form-content search-box results-search">
                                    <div className="inner">
                                        <input autoComplete="off" onChange={handleTextSearch} onKeyDown={handleKeyDown} className="searchfield txt-livesearch input" name="s" value={textSearch} placeholder="Buscar aquí..." type="text" />
                                    </div>
                                </div>
                                <input name="post_type" value="product" type="hidden" />
                                <input name="taxonomy" value="product_cat" type="hidden" />
                                <div className="category">
                                    <select title="product_cat" onChange={changeSelectTagSearch} name="product_cat" id="112546160" className=""
                                            tabIndex="-1">
                                        <option value="">Seleccione Tag</option>
                                        {
                                            taglist.map((tag, index) => (
                                                <option className="level-0" key={index} value={tag}>{tag}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <button type="button" onClick={()=>redirectAndSearchProducts()} className="btn-submit">
                                    <span className="pe-7s-search"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    </>
                    /*
                    <ul className="wpml-menu">
                        <li className="menu-item kreen-dropdown block-language">
                            <a href="#" data-kreen="kreen-dropdown">
                                <img src="/assets/images/en.png"
                                    alt="en" width="18" height="12" />
                                English
                            </a>
                            <span className="toggle-submenu"></span>
                            <ul className="sub-menu">
                                <li className="menu-item">
                                    <a href="#">
                                        <img src="/assets/images/it.png"
                                            alt="it" width="18" height="12" />
                                        Italiano
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="menu-item">
                            <div className="wcml-dropdown product wcml_currency_switcher">
                                <ul>
                                    <li className="wcml-cs-active-currency">
                                        <a className="wcml-cs-item-toggle">USD</a>
                                        <ul className="wcml-cs-submenu">
                                            <li>
                                                <a>EUR</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    */
                    }
                </div>
                <div className="header-mobile-mid">
                    <div className="header-logo">
                        <a href="/">
                            <img alt="Kreen" src="https://res.cloudinary.com/dlaew2qjk/image/upload/v1770757004/san_jose/LOGO_DSJ.png" className="logo" style={{width:"500px"}} />
                        </a>
                    </div>
                </div>
                <div className="header-mobile-right">
                    <div className="header-control-inner">

                        <div className="meta-dreaming">
                            {
                                /*<div className="menu-item block-user block-dreaming kreen-dropdown">
                                    <a className="block-link" href="#">
                                        <span className="pe-7s-user"></span>
                                    </a>
                                    <ul className="sub-menu">
                                        <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--dashboard is-active">
                                            <a href="#">Dashboard</a>
                                        </li>
                                        <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--orders">
                                            <a href="#">Orders</a>
                                        </li>
                                        <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--downloads">
                                            <a href="#">Downloads</a>
                                        </li>
                                        <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-adchair">
                                            <a href="#">Addresses</a>
                                        </li>
                                        <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-account">
                                            <a href="#">Account details</a>
                                        </li>
                                        <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--customer-logout">
                                            <a href="#">Logout</a>
                                        </li>
                                    </ul>
                                </div>*/

                            }
                            <div className="block-minicart block-dreaming kreen-mini-cart kreen-dropdown">
                                <div className="shopcart-dropdown block-cart-link" data-kreen="kreen-dropdown">
                                    <a className="block-link link-dropdown" href="cart.html">
                                        <span className="pe-7s-shopbag"></span>
                                        <span className="count">{cart.length}</span>
                                    </a>
                                </div>
                                <div className="widget kreen widget_shopping_cart">
                                    <div className="widget_shopping_cart_content">
                                        <h3 className="minicart-title">Tu Carrito<span className="minicart-number-items">{cart.length}</span></h3>
                                        <ul className="kreen-mini-cart cart_list product_list_widget">
                                            {
                                                cart.length > 0 ?
                                                <>
                                                <p className='text-primary text-small' style={{width:'350px', overflowWrap:'break-word', paddingLeft:'10px', fontSize:'13px', textAlign:'justify'}}><i className="fa fa-info-circle"></i> Los precios que se muestran son aproximados, pueden cambiar de acuerdo a su gramaje real. Por favor, para obtener mejor información de los precios, hacer click en el botón <b>COTIZAR</b> para ponerse en contacto con el vendedor.</p>
                                                </>
                                                :
                                                <div className='text-center'>
                                                    <h3 className='text-muted'>El carrito está vacío</h3>
                                                </div>
                                            }

                                            {
                                                /**
                                                 * 
                                                <li className="kreen-mini-cart-item mini_cart_item">
                                                    <a href="#" className="remove remove_from_cart_button">×</a>
                                                    <a href="#">
                                                        <img src="/assets/images/apro134-1-600x778.jpg"
                                                            className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                            alt="img" width="600" height="778" />T-shirt with skirt – Pink&nbsp;
                                                    </a>
                                                    <span className="quantity">1 × <span
                                                            className="kreen-Price-amount amount"><span
                                                            className="kreen-Price-currencySymbol">$</span>150.00</span></span>
                                                </li>
                                                 */cart.map((item, index) => (
                                                    <li className="kreen-mini-cart-item mini_cart_item" key={item.productDessId}>
                                                        <a onClick={()=>quitItemCart(item.productDessId)} className="remove remove_from_cart_button" style={{cursor: "pointer"}}>×</a>
                                                        <a href="#">
                                                            <img src={item.url_img_product}
                                                                className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                                alt="img" width="600" height="778" />{item.description}&nbsp;
                                                        </a>
                                                        <span className="quantity">
                                                            {
                                                                item.product_type.tipoProductoId == 2 ?
                                                                <span>
                                                                    <input type="number" data-step="1" step="0.01" data-index={index} max="" onChange={handleInputQuantity} value={item.quantity} title="Qty" className="input-qty input-text qty text border-dark" size="1" pattern="[0-9]*" inputMode="numeric" style={{width: '75px'}} />
                                                                </span>
                                                                :
                                                                <span style={{paddingRight: '10px'}}>
                                                                    <button type='button' onClick={()=>setIncrementDecrement(index, 'decrement')} className="btn btn-dark btn-sm" style={{cursor: "pointer"}}>-</button>
                                                                    <input type="number" data-step="1" min="1" data-index={index} max="" onChange={handleInputQuantity} value={item.quantity} title="Qty" className="input-qty input-text qty text border-dark" size="1" pattern="[0-9]*" inputMode="numeric" style={{width: '75px'}} />
                                                                    <button type='button' onClick={()=>setIncrementDecrement(index, 'increment')} className="btn btn-dark btn-sm" style={{cursor: "pointer"}}>+</button>
                                                                </span>

                                                            }
                                                            <span className='text-muted' style={{paddingRight: '10px'}}>
                                                                {item.dess_unidade.abreviatura}
                                                            </span>
                                                            <span style={{paddingRight: '10px'}}>
                                                                × 
                                                            </span>
                                                            <span className="kreen-Price-amount amount">
                                                                <span className="kreen-Price-currencySymbol">$</span>{parseFloat(item.price1).toFixed(2)}
                                                            </span>
                                                        </span>
                                                        <div className='text-right text-primary'>
                                                            ${parseFloat(item.subtotal).toFixed(2)}
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                        </ul>

                                        <p className="kreen-mini-cart__total total"><strong>Subtotal:</strong>
                                            <span className="kreen-Price-amount amount"><span
                                                    className="kreen-Price-currencySymbol">$</span>{parseFloat(totalCart()).toFixed(2)}</span>
                                        </p>
                                        <p className="kreen-mini-cart__buttons buttons">
                                            {
                                                cart.length > 0 ?
                                                <>
                                                    <a href="#" onClick={()=>limpiarCarrito()} className="button kreen-forward">VACIAR CARRITO</a>
                                                    <a href="#" onClick={()=>sendQuotationWhastapp()} className="button checkout kreen-forward">COTIZAR</a>
                                                </>
                                                :
                                                null
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </header>
    );

    /*return (
        <header>
            <div className="header-wrap-stick">
                <div className="header-position">
                    <div className="header-middle">
                        <div className="kreen-menu-wapper"></div>
                        <div className="header-middle-inner">
                            <div className="header-logo">
                                <a href="index.html">
                                    <img alt="Kreen" src="assets/images/logo.png" className="logo" />
                                </a>
                            </div>
                            
                            <div className="header-menu">
                                <div className="box-header-nav menu-nocenter">
                                    <ul id="menu-primary-menu" className="clone-main-menu kreen-clone-mobile-menu kreen-nav main-menu">
                                        
                                        <li id="menu-item-228" className="menu-item menu-item-type-post_type menu-item-object-megamenu menu-item-228 parent parent-megamenu item-megamenu menu-item-has-children">
                                            <a className="kreen-menu-item-title" title="Categorías" href="#">Categorías</a>
                                            <span className="toggle-submenu"></span>
                                            <div className="submenu megamenu megamenu-shop">
                                                <div className="row">
                                                    {
                                                        categories.map((chck, index) => {

                                                            return (
                                                                <div className="col-md-4" key={index}>
                                                                    {
                                                                        chck.map((category) => {

                                                                            return (
                                                                                <div className="kreen-listitem style-01" key={category.dessCategoryId}>
                                                                                    <div className="listitem-inner">
                                                                                        <h4 className="title">{category.name_category} </h4>
                                                                                        <ul className="listitem-list">
                                                                                            {
                                                                                                category.dess_subcategories.map((subcategory) => {

                                                                                                    return (
                                                                                                        <li key={subcategory.dessSubcategoryId}>
                                                                                                            <a 
                                                                                                                href="#" 
                                                                                                                data-id={subcategory.dessSubcategoryId} 
                                                                                                                onClick={
                                                                                                                    (e) => {
                                                                                                                        e.preventDefault();
                                                                                                                        handleGetProducts(subcategory.dessSubcategoryId)
                                                                                                                    }
                                                                                                                }>{subcategory.name_subcategory} </a>
                                                                                                        </li>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                                <div className="block-menu-bar">
                                    <a className="menu-bar menu-toggle" href="#">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                            
                            <div className="header-control">
                                <div className="header-control-inner">
                                    <div className="meta-dreaming">
                                        <ul className="wpml-menu">
                                            <li className="menu-item kreen-dropdown block-language">
                                                <a href="#" data-kreen="kreen-dropdown">
                                                    <img src="assets/images/en.png"
                                                        alt="en" width="18" height="12" />
                                                    English
                                                </a>
                                                <span className="toggle-submenu"></span>
                                                <ul className="sub-menu">
                                                    <li className="menu-item">
                                                        <a href="#">
                                                            <img src="assets/images/it.png"
                                                                alt="it" width="18" height="12" />
                                                            Italiano
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="menu-item">
                                                <div className="wcml-dropdown product wcml_currency_switcher">
                                                    <ul>
                                                        <li className="wcml-cs-active-currency">
                                                            <a className="wcml-cs-item-toggle">USD</a>
                                                            <ul className="wcml-cs-submenu">
                                                                <li>
                                                                    <a>EUR</a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="header-search kreen-dropdown">
                                            <div className="header-search-inner" data-kreen="kreen-dropdown">
                                                <a href="#" className="link-dropdown block-link">
                                                    <span className="pe-7s-search"></span>
                                                </a>
                                            </div>
                                            <div className="block-search">
                                                <div className="form-search block-search-form kreen-live-search-form">
                                                    <div className="form-content search-box results-search">
                                                        <div className="inner">
                                                            <input autoComplete="off" className="searchfield txt-livesearch input"
                                                                name="s" value="" placeholder="Search here..." type="text" />
                                                        </div>
                                                    </div>
                                                    <input name="post_type" value="product" type="hidden" />
                                                    <input name="taxonomy" value="product_cat" type="hidden" />
                                                    <div className="category">
                                                        <select title="product_cat" name="product_cat"
                                                                className="category-search-option"
                                                                tabIndex="-1">
                                                            <option value="0">All Categories</option>
                                                            <option className="level-0" value="light">Healthy</option>
                                                            <option className="level-0" value="chair">Pumpkin</option>
                                                            <option className="level-0" value="table">Leafy green</option>
                                                            <option className="level-0" value="bed">Soybeans</option>
                                                            <option className="level-0" value="new-arrivals">New arrivals</option>
                                                            <option className="level-0" value="lamp">Summer Sale</option>
                                                            <option className="level-0" value="specials">Raw fruit</option>
                                                            <option className="level-0" value="sofas">Cauliflower</option>
                                                        </select>
                                                    </div>
                                                    <button type="submit" className="btn-submit">
                                                        <span className="pe-7s-search"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="kreen-dropdown-close">x</div>
                                        <div className="menu-item block-user block-dreaming kreen-dropdown">
                                            <a className="block-link" href="my-account.html">
                                                <span className="pe-7s-user"></span>
                                            </a>
                                            <ul className="sub-menu">
                                                <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--dashboard is-active">
                                                    <a href="#">Dashboard</a>
                                                </li>
                                                <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--orders">
                                                    <a href="#">Orders</a>
                                                </li>
                                                <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--downloads">
                                                    <a href="#">Downloads</a>
                                                </li>
                                                <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-adchair">
                                                    <a href="#">Addresses</a>
                                                </li>
                                                <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-account">
                                                    <a href="#">Account details</a>
                                                </li>
                                                <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--customer-logout">
                                                    <a href="#">Logout</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="block-minicart block-dreaming kreen-mini-cart kreen-dropdown">
                                            <div className="shopcart-dropdown block-cart-link" data-kreen="kreen-dropdown">
                                                <a className="block-link link-dropdown" href="cart.html">
                                                    <span className="pe-7s-shopbag"></span>
                                                    <span className="count">3</span>
                                                </a>
                                            </div>
                                            <div className="widget kreen widget_shopping_cart">
                                                <div className="widget_shopping_cart_content">
                                                    <h3 className="minicart-title">Your Cart<span className="minicart-number-items">3</span></h3>
                                                    <ul className="kreen-mini-cart cart_list product_list_widget">
                                                        <li className="kreen-mini-cart-item mini_cart_item">
                                                            <a href="#" className="remove remove_from_cart_button">×</a>
                                                            <a href="#">
                                                                <img src="assets/images/apro134-1-600x778.jpg"
                                                                    className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                                    alt="img" width="600" height="778" />T-shirt with skirt – Pink&nbsp;
                                                            </a>
                                                            <span className="quantity">1 × <span
                                                                    className="kreen-Price-amount amount"><span
                                                                    className="kreen-Price-currencySymbol">$</span>150.00</span></span>
                                                        </li>
                                                        <li className="kreen-mini-cart-item mini_cart_item">
                                                            <a href="#" className="remove remove_from_cart_button">×</a>
                                                            <a href="#">
                                                                <img src="assets/images/apro1113-600x778.jpg"
                                                                    className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                                    alt="img" width="600" height="778" />Abstract Sweatshirt&nbsp;
                                                            </a>
                                                            <span className="quantity">1 × <span
                                                                    className="kreen-Price-amount amount"><span
                                                                    className="kreen-Price-currencySymbol">$</span>129.00</span></span>
                                                        </li>
                                                        <li className="kreen-mini-cart-item mini_cart_item">
                                                            <a href="#" className="remove remove_from_cart_button">×</a>
                                                            <a href="#">
                                                                <img src="assets/images/apro201-1-600x778.jpg"
                                                                    className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                                    alt="img" width="600" height="778" />Iridium Spark Plug&nbsp;
                                                            </a>
                                                            <span className="quantity">1 × <span
                                                                    className="kreen-Price-amount amount"><span
                                                                    className="kreen-Price-currencySymbol">$</span>139.00</span></span>
                                                        </li>
                                                    </ul>
                                                    <p className="kreen-mini-cart__total total"><strong>Subtotal:</strong>
                                                        <span className="kreen-Price-amount amount"><span
                                                                className="kreen-Price-currencySymbol">$</span>418.00</span>
                                                    </p>
                                                    <p className="kreen-mini-cart__buttons buttons">
                                                        <a href="cart.html" className="button kreen-forward">Viewcart</a>
                                                        <a href="checkout.html" className="button checkout kreen-forward">Checkout</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header-mobile">
                <div className="header-mobile-left">
                    <div className="block-menu-bar">
                        <a className="menu-bar menu-toggle" href="#">
                            <span></span>
                            <span></span>
                            <span></span>
                        </a>
                    </div>
                    <div className="header-search kreen-dropdown">
                        <div className="header-search-inner" data-kreen="kreen-dropdown">
                            <a href="#" className="link-dropdown block-link">
                                <span className="pe-7s-search"></span>
                            </a>
                        </div>
                        <div className="block-search">
                            <div className="form-search block-search-form kreen-live-search-form">
                                <div className="form-content search-box results-search">
                                    <div className="inner">
                                        <input autoComplete="off" className="searchfield txt-livesearch input" name="s" value=""
                                            placeholder="Search here..." type="text" />
                                    </div>
                                </div>
                                <input name="post_type" value="product" type="hidden" />
                                <input name="taxonomy" value="product_cat" type="hidden" />
                                <div className="category">
                                    <select title="product_cat" name="product_cat" id="112546160" className="category-search-option"
                                            tabIndex="-1"
                                            style={{display: 'none'}}>
                                        <option value="0">All Categories</option>
                                        <option className="level-0" value="light">Healthy</option>
                                        <option className="level-0" value="chair">Pumpkin</option>
                                        <option className="level-0" value="table">Leafy green</option>
                                        <option className="level-0" value="bed">Soybeans</option>
                                        <option className="level-0" value="new-arrivals">New arrivals</option>
                                        <option className="level-0" value="lamp">Summer Sale</option>
                                        <option className="level-0" value="specials">Raw fruit</option>
                                        <option className="level-0" value="sofas">Cauliflower</option>
                                    </select>
                                </div>
                                <button type="submit" className="btn-submit">
                                    <span className="pe-7s-search"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ul className="wpml-menu">
                        <li className="menu-item kreen-dropdown block-language">
                            <a href="#" data-kreen="kreen-dropdown">
                                <img src="assets/images/en.png"
                                    alt="en" width="18" height="12" />
                                English
                            </a>
                            <span className="toggle-submenu"></span>
                            <ul className="sub-menu">
                                <li className="menu-item">
                                    <a href="#">
                                        <img src="assets/images/it.png"
                                            alt="it" width="18" height="12" />
                                        Italiano
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li className="menu-item">
                            <div className="wcml-dropdown product wcml_currency_switcher">
                                <ul>
                                    <li className="wcml-cs-active-currency">
                                        <a className="wcml-cs-item-toggle">USD</a>
                                        <ul className="wcml-cs-submenu">
                                            <li>
                                                <a>EUR</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="header-mobile-mid">
                    <div className="header-logo">
                        <a href="#">
                            <img alt="Kreen" src="assets/images/logo.png" className="logo" />
                        </a>
                    </div>
                </div>
                <div className="header-mobile-right">
                    <div className="header-control-inner">
                        <div className="meta-dreaming">
                            <div className="menu-item block-user block-dreaming kreen-dropdown">
                                <a className="block-link" href="#">
                                    <span className="pe-7s-user"></span>
                                </a>
                                <ul className="sub-menu">
                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--dashboard is-active">
                                        <a href="#">Dashboard</a>
                                    </li>
                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--orders">
                                        <a href="#">Orders</a>
                                    </li>
                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--downloads">
                                        <a href="#">Downloads</a>
                                    </li>
                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-adchair">
                                        <a href="#">Addresses</a>
                                    </li>
                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--edit-account">
                                        <a href="#">Account details</a>
                                    </li>
                                    <li className="menu-item kreen-MyAccount-navigation-link kreen-MyAccount-navigation-link--customer-logout">
                                        <a href="#">Logout</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="block-minicart block-dreaming kreen-mini-cart kreen-dropdown">
                                <div className="shopcart-dropdown block-cart-link" data-kreen="kreen-dropdown">
                                    <a className="block-link link-dropdown" href="cart.html">
                                        <span className="pe-7s-shopbag"></span>
                                        <span className="count">3</span>
                                    </a>
                                </div>
                                <div className="widget kreen widget_shopping_cart">
                                    <div className="widget_shopping_cart_content">
                                        <h3 className="minicart-title">Your Cart<span className="minicart-number-items">3</span></h3>
                                        <ul className="kreen-mini-cart cart_list product_list_widget">
                                            <li className="kreen-mini-cart-item mini_cart_item">
                                                <a href="#" className="remove remove_from_cart_button">×</a>
                                                <a href="#">
                                                    <img src="assets/images/apro134-1-600x778.jpg"
                                                        className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                        alt="img" width="600" height="778" />T-shirt with skirt – Pink&nbsp;
                                                </a>
                                                <span className="quantity">1 × <span
                                                        className="kreen-Price-amount amount"><span
                                                        className="kreen-Price-currencySymbol">$</span>150.00</span></span>
                                            </li>
                                            <li className="kreen-mini-cart-item mini_cart_item">
                                                <a href="#" className="remove remove_from_cart_button">×</a>
                                                <a href="#">
                                                    <img src="assets/images/apro1113-600x778.jpg"
                                                        className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                        alt="img" width="600" height="778" />Abstract Sweatshirt&nbsp;
                                                </a>
                                                <span className="quantity">1 × <span
                                                        className="kreen-Price-amount amount"><span
                                                        className="kreen-Price-currencySymbol">$</span>129.00</span></span>
                                            </li>
                                            <li className="kreen-mini-cart-item mini_cart_item">
                                                <a href="#" className="remove remove_from_cart_button">×</a>
                                                <a href="#">
                                                    <img src="assets/images/apro201-1-600x778.jpg"
                                                        className="attachment-kreen_thumbnail size-kreen_thumbnail"
                                                        alt="img" width="600" height="778" />Iridium Spark Plug&nbsp;
                                                </a>
                                                <span className="quantity">1 × <span
                                                        className="kreen-Price-amount amount"><span
                                                        className="kreen-Price-currencySymbol">$</span>139.00</span></span>
                                            </li>
                                        </ul>
                                        <p className="kreen-mini-cart__total total"><strong>Subtotal:</strong>
                                            <span className="kreen-Price-amount amount"><span
                                                    className="kreen-Price-currencySymbol">$</span>418.00</span>
                                        </p>
                                        <p className="kreen-mini-cart__buttons buttons">
                                            <a href="cart.html" className="button kreen-forward">Viewcart</a>
                                            <a href="checkout.html" className="button checkout kreen-forward">Checkout</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </header>
    );*/
}

export default Navbar1;